// extracted by mini-css-extract-plugin
module.exports = {"body":"MemoForm__body--2CwJD","confirm":"MemoForm__confirm--3LQ01","dateWrap":"MemoForm__dateWrap--1svbS"};